import { DuplicatePersonDialog } from "./DuplicatePersonDialog";

export default DuplicatePersonDialog;
